export const RESTORE_STATE = 'RESTORE_STATE';

export function loadState() {
  try {
    const serializedState = localStorage.getItem('kokopelli_state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
}

export function saveState(state) {
  try {
    const {salon: {selectedSalonId}, auth: {token}} = state;
    const toSave = {salon: {selectedSalonId}, auth: {token}};
    const serializedState = JSON.stringify(toSave);
    localStorage.setItem('kokopelli_state', serializedState);
  } catch (err) {
    // ignore write errors
  }
}



// WEBPACK FOOTER //
// ./src/persistState.js